import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const storedAuthData = localStorage.getItem('authData');
  const initialAuthData = storedAuthData ? JSON.parse(storedAuthData) : {};

  const [auth, setAuth] = useState(initialAuthData);
  const [permissions, setPermissions] = useState();

  // Fetch user permissions
  useEffect(() => {
    setPermissions(initialAuthData)
  },[])
    
  // smoke this guy

  // useEffect(() => {
  //   localStorage.setItem('authData', JSON.stringify({ auth, permissions }));
  // }, [auth, permissions]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, permissions, setPermissions }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
